"use client"

import { ReactNode } from "react"
import { RecursiveTranslations } from "@/data/types"
import Image from "next/image"
import { ArrowRightIcon } from "@/components/icons"
import CTAButtonLink from "@/components/common/cta/CTAButtonLink"
import useEmblaCarousel from "embla-carousel-react"
import AutoScroll from "embla-carousel-auto-scroll"

import partner1Logo from '@/assets/images/Select_Group.svg'
import partner2Logo from '@/assets/images/Binghatti.svg'
import partner3Logo from '@/assets/images/Damac.svg'
import partner4Logo from '@/assets/images/Ellington.svg'
import partner5Logo from '@/assets/images/Majid_Al_Futtaim.svg'
import partner6Logo from '@/assets/images/Emaar.svg'

interface Props {
  translations: RecursiveTranslations
  exploreAllLink: string
}

const partners = [ partner1Logo, partner2Logo, partner3Logo, partner4Logo, partner5Logo, partner6Logo ]

export default function Partners({ translations, exploreAllLink }: Props) {
  const [emblaRef] = useEmblaCarousel({ loop: true, dragFree: true }, [AutoScroll({ speed: 1.5, stopOnInteraction: false, stopOnMouseEnter: false })])

  return (
    <div className="flex flex-col max-w-[1440px] mx-auto px-[20px] md:px-[50px] pb-[60px] gap-[60px] items-center text-center overflow-hidden">
      <div className="flex flex-col gap-[30px] items-center">
        <h5 className="font-normal text-[17px] lg:text-[20px] leading-[30px] text-[#1B1D2B]">
          {translations?.title as string}
        </h5>

        <div className="overflow-hidden w-full" ref={emblaRef}>
          <div className="flex">
            {[...partners, ...partners].map((logo, index) => (
              <div
                key={index}
                className="flex-shrink-0 flex items-center justify-center px-[30px] md:px-[50px]"
              >
                <Image
                  src={logo}
                  alt={`Partner ${index + 1}`}
                  className="w-[120px] h-auto object-contain"
                />
              </div>
            ))}
          </div>
        </div>
      </div>

      <CTAButtonLink
        href={exploreAllLink}
        rightIcon={<ArrowRightIcon color="white" width={20} height={20} />}
      >
        {translations?.buttonLabel as ReactNode}
      </CTAButtonLink>
    </div>
  )
}
